import { Component, Input, EventEmitter, Output, SimpleChange, ChangeDetectorRef, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderCardWithIconTitleDescriptionComponent } from '../card-icon-title-description/card-icon-title-description.component';
import { JoyrideModule } from 'ngx-joyride';
import { BrowserStorageManagementService } from 'libs/shared/src/lib/services/browser-storage-management-service/browser-storage-management.service';
import { ColorConfig } from '../../utils/shared';
import { RappiderInputGroupModule } from '../input-group/input-group.module';
import { InputGroupComponentConfig } from '../../utils/input-group';
import { IconType } from '../../utils/icon';
import { FormsModule } from '@angular/forms';
import { isEqual } from 'lodash';

export interface CardIconTitleDescription {
  [key: string]: any; // Allow additional properties
  id: string;
  title: string;
  key?: string;
  iconName?: string;
  description?: string;
  color?: ColorConfig;
}

@Component({
  selector: 'rappider-card-icon-title-description-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RappiderCardWithIconTitleDescriptionComponent,
    JoyrideModule,
    RappiderInputGroupModule
  ],
  templateUrl: './card-icon-title-description-list.component.html',
  styleUrls: ['./card-icon-title-description-list.component.scss'],
})
export class RappiderCardWithIconTitleDescriptionListComponent implements OnInit, OnChanges {
  @Input() items: CardIconTitleDescription[] | undefined;
  @Input() customCardContainerCssClass?: string = '';
  @Input() compactCards? = false;
  @Input() searchEnabled? = false;

  @Output() cardClick = new EventEmitter<{ id: string; title: string; key?: string; optional: any }>();
  @Output() checkboxValueChange = new EventEmitter();

  cardListSearchText: string;
  /* card data is filtered listGridData according to the search text (and possible filters) */
  cardSearchInputConfig: InputGroupComponentConfig = {
    textbox: {
      placeholder: 'Type to search'
    },
    suffixIcon: {
      name: 'fas fa-search',
      type: IconType.FontAwesome
    }
  };

  filteredItems: CardIconTitleDescription[] | undefined;

  constructor(private cdr: ChangeDetectorRef, private browserStorageManagementService: BrowserStorageManagementService) { }

  ngOnInit(): void {
    this.filteredItems = [...this.items ?? []];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && !changes['items'].isFirstChange()) {
      // if previous value is different from current value
      if (!isEqual(changes['items'].previousValue, changes['items'].currentValue)) {
        this.filteredItems = [...this.items];
        this.cardListSearchText = '';
        this.cdr.detectChanges();
      }
    }
  }

  onCardClick(item: CardIconTitleDescription, optional?: any) {
    this.cardClick.emit({ id: item.id, title: item.title, key: item.key, ...item, optional });
  }

  onSearchInputChange(event: any) {
    if (this.items) {
      if (this.cardListSearchText.trim()) {
        this.filteredItems = this.items.filter(item =>
          item.title?.toLowerCase().includes(this.cardListSearchText?.trim().toLowerCase()) ||
          item.key?.toLowerCase().includes(this.cardListSearchText?.trim().toLowerCase()) ||
          item.id?.toLowerCase().includes(this.cardListSearchText?.trim().toLowerCase())
        );
      } else {
        this.filteredItems = [...this.items];
      }

    }
  }

  onCheckboxValueChange(value){
    this.checkboxValueChange.emit(value);
  }

}
